
import { telemetry } from '../../../@vendor/Posthog';
import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { numberStep } from '../../../concepts/commands/CommandWizard';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { Physicals } from '../../canvas/entities/Physicals';
import { Spinner } from './Spinner';
import { SpinnerItem } from './SpinnerItem';

export const createSpinner = defineCommand(
    'createSpinner',
    'Create: Spinner...',
    (cc, [segments]: [number?]) => {
        const objects = cc.resolve(ObjectManager);

        Physicals.createAtCameraPosition(cc, Spinner, x => {
            x.width = 400;
            x.height = 400;

            objects.update(u => {

                for (let i = 0; i < (segments || i); i++) {
                    const item = u.create(SpinnerItem);
                    item.text = `Item ${i + 1}`;
                    x.add(item);
                }
            });
        });
    },
    [
        numberStep('segments', 'How many segments?', 6)
    ]
);

export const spinnerLoad = defineCommand(
    'spinnerLoad',
    'Spinner: Load...',
    (cc, [targetId, ...items]: string[]) => {

        const objects = cc.resolve(ObjectManager);
        const spinner = resolveSubject(cc, targetId)?.as(Spinner);
        if (!spinner) return;

        objects.update(u => {

            // Empty
            for (const tm of spinner.polarize(SpinnerItem)) {
                u.delete(tm.removeSelf());
            }

            // Load
            for (const tm of items) {
                const item = u.create(SpinnerItem);
                item.text = tm;
                spinner.add(item);
            }

            spinner.round = uuid();
            spinner.value = 0;
        });
    }
);

export const spinnerSpin = defineCommand(
    'spinnerSpin',
    'Spinner: Spin',
    (cc, [targetId]: [string]) => {

        const objects = cc.resolve(ObjectManager);
        const spinner = resolveSubject(cc, targetId)?.as(Spinner);
        if (!spinner) return;

        objects.update(u => {
            u.set('history', 'skip');

            const fullSpin = 2 * Math.PI;
            const angle = fullSpin * Math.random();

            const mul = spinner.value > 5 ? 1 : -1;
            spinner.winnerVisible = true;
            spinner.count++;
            spinner.value += ((fullSpin * 5) + angle) * mul;
        });

        telemetry.emit('interaction.spinner');
    },
    [
        numberStep('segments', 'How many segments?', 6)
    ]
);

export const spinnerReset = defineCommand(
    'spinnerSpin',
    'Spinner: Reset',
    (cc, [targetId]: [string]) => {

        const objects = cc.resolve(ObjectManager);
        const spinner = resolveSubject(cc, targetId)?.as(Spinner);
        if (!spinner) return;

        objects.update(() => {

            for (const tm of spinner.polarize(SpinnerItem)) {
                tm.hidden = false;
            }

            spinner.winnerVisible = false;
            spinner.round = uuid();
            spinner.value = 0;
        });
    },
);

export const spinnerRemove = defineCommand(
    'spinnerRemove',
    'Spinner: Remove Winner',
    (cc, [targetId]: [string]) => {

        const objects = cc.resolve(ObjectManager);
        const spinner = resolveSubject(cc, targetId)?.as(Spinner);
        if (!spinner) return;

        objects.update(() => {

            const winner = spinner
                .polarize(SpinnerItem)
                .find(x => x.id === spinner.winnerId);

            if (winner) {
                winner.hidden = true;
            }

            spinner.winnerVisible = false;
            spinner.round = uuid();
        });
    },
    [
        numberStep('segments', 'How many segments?', 6)
    ]
);

export const inSpinnerCommands = () => inCommands(
    createSpinner,
);

